import * as mutation from "./mutation-types";
import { stateMerge } from "vue-object-merge";
import { getInitialState, getUnloadedState } from "./state";

export const mutations = {
  [mutation.STATE_RESET](state) {
    stateMerge(state, getInitialState());
  },
  [mutation.STATE_UNLOAD](state) {
    stateMerge(state, getUnloadedState());
  },
  [mutation.STATE_HIDE_ERROR](state, hideArgument) {
    stateMerge(state[hideArgument], { error: { show: false } });
  },

  [mutation.UPDATE_TOGGLES](state, toggles) {
    stateMerge(state.dashboard, toggles);
  },

  [mutation.CREATE_STARTED](state, levyCollectionId) {
    state.create.saving = true;
    state.create.originalLevyCollectionId = levyCollectionId;
  },
  [mutation.CREATE_SUCCEEDED](state, data) {
    state.create.saving = false;
    state.create.sandboxLevyCollectionId = data.id;
  },
  [mutation.CREATE_FAILED](state, error) {
    state.create.saving = false;
    state.create.error.details = error;
    state.create.error.show = true;
  },

  [mutation.DELETE_STARTED](state, levyCollectionId) {
    state.delete.processing = true;
    state.delete.levyCollectionId = levyCollectionId;
  },
  [mutation.DELETE_SUCCEEDED](state) {
    state.delete.processing = false;
  },
  [mutation.DELETE_FAILED](state) {
    state.delete.processing = false;
  },

  [mutation.LOAD_ORIGINAL_LEVY_COLLECTION_STARTED](state, levyCollectionId) {
    state.original.loading = true;
    state.original.levyCollectionId = levyCollectionId;
  },
  [mutation.LOAD_ORIGINAL_LEVY_COLLECTION_SUCCEEDED](state, { riskFactors, fees, levyCollection }) {
    state.original.loading = false;
    state.original.loaded = true;
    state.original.riskFactors = riskFactors;
    state.original.fees = fees;
    state.original.levyCollection = levyCollection;
  },
  [mutation.LOAD_ORIGINAL_LEVY_COLLECTION_FAILED](state) {
    state.original.loading = false;
    state.original.loaded = false;
  }
};
